module.exports = __webpack_public_path__ + "static/media/Corey-Caplan.5dbfd590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Corey-Caplan.png
// module id = 179
// module chunks = 0